import React from 'react';
import './Contact.scss';

const Contact = ({ setProductPosition }) => {
  return (
    <div id="sixth" className="Contact">
      <div className="ContactTitle">Contact</div>
      <div className="ContactMain">Instagram</div>
      <a
        href="https://instagram.com/namsanworks"
        target="_blank"
        rel="noreferrer"
      >
        <img
          className="ContactImage"
          src="/images/Instagram.svg"
          alt="instargram"
        />
      </a>
      <a
        href="https://instagram.com/namsanworks"
        target="_blank"
        rel="noreferrer"
      >
        <div className="ContactMain2"> @namsanworks</div>
      </a>
    </div>
  );
};

export default Contact;
